import { RouteProps } from 'react-router';

import ROUTES from '@/common/routes';

import BuySellPage from './BuySell.page';
import ManagedSellInvestmentsPage from './ManagedSellInvestments.page';
import ManagedSwitchAllocationPage from './ManagedSwitchAllocation.page';
import ManagedSwitchEmptyAllocationPage from './ManagedSwitchEmptyAllocation.page';
import ManagedSwitchEmptyFundingAmountPage from './ManagedSwitchEmptyFundingAmount.page';
import ManagedSwitchEmptyQuestionnairePage from './ManagedSwitchEmptyQuestionnaire.page';
import ManagedSwitchFundingAmountPage from './ManagedSwitchFundingAmount.page';
import ManagedSwitchQuestionnairePage from './ManagedSwitchQuestionnaire.page';
import SelfDirectedPage from './SelfDirected.page';
import SelfDirectedAllocationPage from './SelfDirectedAllocation.page';
import SelfDirectedInvestMorePage from './SelfDirectedInvestMore.page';
import SelfDirectedQuestionnairePage from './SelfDirectedQuestionnaire.page';
import SelfDirectedSellInvestmentsPage from './SelfDirectedSellInvestments.page';
import SelfDirectedSwitchAllocationPage from './SelfDirectedSwitchAllocation.page';
import SelfDirectedSwitchEmptyAllocationPage from './SelfDirectedSwitchEmptyAllocation.page';
import SelfDirectedSwitchEmptyQuestionnairePage from './SelfDirectedSwitchEmptyQuestionnaire.page';
import SelfDirectedSwitchEmptySelectPage from './SelfDirectedSwitchEmptySelect.page';
import SelfDirectedSwitchQuestionnairePage from './SelfDirectedSwitchQuestionnaire.page';
import SelfDirectedSwitchSelectPage from './SelfDirectedSwitchSelect.page';
import TaxFormsPage from './TaxForms.page';
type Route = RouteProps & {
  authed?: boolean;
};

export const INVESTMENTS_ROUTES: Route[] = [
  {
    path: ROUTES.SELF_DIRECTED_SWITCH_QUESTIONNAIRES(),
    authed: true,
    component: SelfDirectedSwitchQuestionnairePage,
  },
  {
    path: ROUTES.SELF_DIRECTED_EMPTY_SWITCH_QUESTIONNAIRE(),
    authed: true,
    component: SelfDirectedSwitchEmptyQuestionnairePage,
  },
  {
    path: ROUTES.SELF_DIRECTED_EMPTY_SWITCH_SELECT(),
    authed: true,
    component: SelfDirectedSwitchEmptySelectPage,
  },
  {
    path: ROUTES.SELF_DIRECTED_EMPTY_SWITCH_ALLOCATION(),
    authed: true,
    component: SelfDirectedSwitchEmptyAllocationPage,
  },

  {
    path: ROUTES.MANAGED_SWITCH_EMPTY_QUESTIONNAIRE(),
    authed: true,
    component: ManagedSwitchEmptyQuestionnairePage,
  },
  {
    path: ROUTES.MANAGED_SWITCH_EMPTY_FUNDING_AMOUNT(),
    authed: true,
    component: ManagedSwitchEmptyFundingAmountPage,
  },
  {
    path: ROUTES.MANAGED_SWITCH_EMPTY_ALLOCATION(),
    authed: true,
    component: ManagedSwitchEmptyAllocationPage,
  },
  {
    path: ROUTES.TAX_FORMS(),
    authed: true,
    component: TaxFormsPage,
  },
  {
    path: ROUTES.MANAGED_SWITCH_ALLOCATION(),
    authed: true,
    component: ManagedSwitchAllocationPage,
  },
  {
    path: ROUTES.MANAGED_SWITCH_FUNDING_AMOUNT(),
    authed: true,
    component: ManagedSwitchFundingAmountPage,
  },
  {
    path: ROUTES.MANAGED_SWITCH_QUESTIONNAIRE(),
    authed: true,
    component: ManagedSwitchQuestionnairePage,
  },
  {
    path: ROUTES.MANAGED_SELL_INVESTMENTS(),
    authed: true,
    component: ManagedSellInvestmentsPage,
  },

  {
    path: ROUTES.SELF_DIRECTED_SELL_INVESTMENTS(),
    authed: true,
    component: SelfDirectedSellInvestmentsPage,
  },
  {
    path: ROUTES.SELF_DIRECTED_QUESTIONNAIRE(),
    authed: true,
    component: SelfDirectedQuestionnairePage,
  },
  {
    path: ROUTES.SELF_DIRECTED_INVEST_MORE(),
    authed: true,
    component: SelfDirectedInvestMorePage,
  },
  {
    path: ROUTES.SELF_DIRECTED_SWITCH_ALLOCATION(),
    authed: true,
    component: SelfDirectedSwitchAllocationPage,
  },
  {
    path: ROUTES.SELF_DIRECTED_SWITCH_SELECT(),
    authed: true,
    component: SelfDirectedSwitchSelectPage,
  },
  {
    path: ROUTES.SELF_DIRECTED_ALLOCATION(),
    authed: true,
    component: SelfDirectedAllocationPage,
  },
  {
    path: ROUTES.SELF_DIRECTED(),
    authed: true,
    component: SelfDirectedPage,
  },
  {
    path: `${ROUTES.BUY_SELL}`,
    authed: true,
    component: BuySellPage,
  },
];
export default INVESTMENTS_ROUTES;
